// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_ReconnectDeviceInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/devices_franquias/reconnect_device
 *
 * Reconnects a WhatsApp device via Evolution API.
 */
import { registerContract } from './validate'

export interface DevicesFranquias_ReconnectDeviceInput {
instance_name: string
provider_type?: string
}

registerContract('DevicesFranquias_ReconnectDeviceInput', {
  instance_name: { type: 'string',  required: true },
  provider_type: { type: 'string',  required: false },
})
